@if ((loggedUser$|ngrxPush); as loggedUser) {
  <div>
    @if (loggedUser.role?.code === RoleCode.CompanyUser) {
      <div>
        @if ( formPartecipata$ | async; as form) {
          <form
            [ngrxFormState]="form"
            (submit)="onSubmitP(form)"
            >
            <div class="modal-header">
              <div class="d-flex align-items-center">
                <h4 class="modal-title" id="modal-basic-title">Anno di esercizio</h4>
              </div>
              <ideapa-icon-button
                icon="close"
                cssClasses="text-primary hover-bg-primary"
                (clicked)="cancel()"
                >
              </ideapa-icon-button>
            </div>
            <div class="modal-body">
              <div class="mt-4 col-4">
                <ideapa-numeric-field
                  [showGroupSeparator]="false"
                  [nullable]="true"
                  [ngrxFormControlState]="form.controls.anno"
                  [errors]="form.controls.anno.errors | ngrxFormsErr"
                  [shouldShowError]="form.controls.anno.isInvalid && form.controls.anno.isSubmitted"
                  >
                </ideapa-numeric-field>
              </div>
              @if (showWarning) {
                <div class="mt-4 warning-alert p-3">
                  La selezione di un nuovo anno comporta la chiusura di tutte le tab
                  relative all'anno di esercizio attualmente selezionato. <br />
                  <strong
                    >Tutte le modifiche effettuate in tali tab, se NON sono state
                    salvate, verranno perse con la conferma della nuova selezione.
                    Confermi?</strong
                    >
                  </div>
                }
              </div>
              <div class="modal-footer">
                <ideapa-button
                  class="me-2"
                  [cssClasses]="'btn-outline-primary'"
                  [text]="'Annulla'"
                  (clicked)="cancel()"
                ></ideapa-button>
                <ideapa-button
                  type="submit"
                  [cssClasses]="'btn-primary'"
                  [text]="'Conferma'"
                ></ideapa-button>
              </div>
            </form>
          }
        </div>
      }
      @if (loggedUser.role?.code !== RoleCode.CompanyUser) {
        <div>
          @if ( form$ | async; as form) {
            <form
              [ngrxFormState]="form"
              (submit)="onSubmit(form)"
              >
              <div class="modal-header">
                <div class="d-flex align-items-center">
                  <h4 class="modal-title" id="modal-basic-title">
                    Ente ed Anno di esercizio
                  </h4>
                </div>
                <ideapa-icon-button
                  icon="close"
                  cssClasses="text-primary hover-bg-primary"
                  (clicked)="cancel()"
                  >
                </ideapa-icon-button>
              </div>
              <div class="modal-body">
                <div class="col-8">
                  <ideapa-select-field
                    [label]="'Ente'"
                    [items]="entiForSelect"
                    [bindValue]="$any(undefined)"
                    [bindLabel]="'description'"
                    [ngrxFormControlState]="form.controls.ente"
                    [errors]="form.controls.ente.errors | ngrxFormsErr"
                    [searchable]="true"
                    [placeholder]="'Seleziona ente'"
                    [shouldShowError]="form.controls.ente.isInvalid &&form.controls.ente.isSubmitted"
                    >
                  </ideapa-select-field>
                </div>
                <div class="mt-4 col-4">
                  <ideapa-numeric-field
                    [showGroupSeparator]="false"
                    [nullable]="true"
                    [label]="'Anno di esercizio'"
                    [ngrxFormControlState]="form.controls.anno"
                    [errors]="form.controls.anno.errors | ngrxFormsErr"
                    [shouldShowError]="form.controls.anno.isInvalid && form.controls.anno.isSubmitted"
                    >
                  </ideapa-numeric-field>
                </div>
                @if (showWarning) {
                  <div class="mt-4 warning-alert p-3">
                    La selezione di nuovi parametri per anno e/o ente, comporta la
                    chiusura di tutte le tab relative ad anno ed ente attualmente
                    selezionati. <br />
                    <strong
                      >Tutte le modifiche effettuate in tali tab, se NON sono state
                      salvate, verranno perse con la conferma della nuova selezione.
                      Confermi?</strong
                      >
                    </div>
                  }
                </div>
                <div class="modal-footer">
                  <ideapa-button
                    class="me-2"
                    [cssClasses]="'btn-outline-primary'"
                    [text]="'Annulla'"
                    (clicked)="cancel()"
                  ></ideapa-button>
                  <ideapa-button
                    type="submit"
                    [cssClasses]="'btn-primary'"
                    [text]="'Conferma'"
                  ></ideapa-button>
                </div>
              </form>
            }
          </div>
        }
      </div>
    }
